// extracted by mini-css-extract-plugin
export default {"header":"panel-module___header___c17fcf10","container":"panel-module___container___f576487f"};